import { z } from "zod";
const absolutePathSchema = z
    .string()
    .regex(/^\//, "Route paths must be absolute");
export const policyIdSchema = z.enum([
    "terms",
    "privacy",
    "refunds",
    "cookies",
]);
export const consentCategorySchema = z.enum([
    "essential",
    "functional",
    "analytics",
    "marketing",
]);
export const requiredPolicyLinkSchema = z.object({
    policyId: policyIdSchema,
    href: absolutePathSchema,
    label: z.string().min(1),
});
export const externalLegalApprovalMetadataSchema = z.object({
    status: z.enum(["not-provided", "pending", "provided"]),
    provider: z.string().min(1).optional(),
    reference: z.string().min(1).optional(),
    providedAt: z.string().datetime().optional(),
});
export const consentManagerOptionsSchema = z.object({
    policyVersion: z.string().trim().min(1),
    categories: z.array(consentCategorySchema).min(1),
    requiredPolicies: z.array(requiredPolicyLinkSchema),
    externalLegalApproval: externalLegalApprovalMetadataSchema,
});
export const policyContentSchema = z.object({
    title: z.string().min(1),
    markdown: z.string().min(1),
    lastUpdated: z.string().min(1),
});
export const faqItemSchema = z.object({
    id: z.string().min(1),
    category: z.string().min(1),
    question: z.string().min(1),
    answer: z.string().min(1),
});
export const legalFeatureConfigSchema = z.object({
    policyVersion: z.string().min(1),
    consentStorageKey: z.string().min(1).default("gsb-cookie-consent"),
    consentDelayMs: z.number().int().min(0).max(30_000).default(0),
    paths: z
        .object({
        terms: absolutePathSchema.default("/legal/terms"),
        privacy: absolutePathSchema.default("/legal/privacy"),
        refunds: absolutePathSchema.default("/legal/refunds"),
        cookies: absolutePathSchema.default("/legal/cookies"),
        faq: absolutePathSchema.default("/faq"),
    })
        .default({}),
    policies: z.object({
        terms: policyContentSchema,
        privacy: policyContentSchema,
        refunds: policyContentSchema,
        cookies: policyContentSchema,
    }),
    faq: z.object({
        title: z.string().min(1),
        subtitle: z.string().optional(),
        allCategoriesLabel: z.string().min(1).default("All"),
        items: z.array(faqItemSchema),
    }),
    consent: z.object({
        title: z.string().min(1),
        description: z.string().min(1),
        acceptLabel: z.string().min(1),
        rejectLabel: z.string().min(1),
        closeLabel: z.string().min(1),
        categories: z.array(consentCategorySchema).min(1).default(["essential"]),
        requiredPolicies: z.array(requiredPolicyLinkSchema).default([]),
    }),
    externalLegalApproval: externalLegalApprovalMetadataSchema.default({
        status: "not-provided",
    }),
    shell: z
        .object({
        eyebrow: z.string(),
        lastUpdatedLabel: z.string(),
        navigationLabel: z.string(),
        readPolicyLabel: z.string(),
        contactLabel: z.string(),
        backToTopLabel: z.string(),
        loadingLabel: z.string(),
        errorLabel: z.string(),
        emptyLabel: z.string(),
        customizeLabel: z.string(),
        savePreferencesLabel: z.string(),
        settingsLabel: z.string(),
        preferencesTitle: z.string(),
        preferencesDescription: z.string(),
        categoriesLabel: z.string(),
        cancelLabel: z.string(),
        categoryLabels: z.record(consentCategorySchema, z.string()),
    })
        .optional(),
});
export const persistedConsentSchema = z.object({
    decision: z.enum(["accepted", "rejected", "customized"]),
    policyVersion: z.string().min(1),
    decidedAt: z.string().datetime(),
    categories: z.record(consentCategorySchema, z.boolean()).optional(),
});
//# sourceMappingURL=contracts.js.map